import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { lucideLock } from '@ng-icons/lucide';
import { HlmButton } from '@lite-workspace/shared/helm-ui/button';

// Один вид запертой выдачи для всех поверхностей гейта: имена пустых полей здесь не перечисляются —
// фотограф видит их подсвеченными на самой обложке, куда ведёт кнопка.
@Component({
  selector: 'app-cover-gate-card',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgIcon, HlmButton],
  viewProviders: [provideIcons({ lucideLock })],
  host: { class: 'block' },
  template: `
    <div class="flex items-start gap-3 rounded-[var(--r-l)] border border-line2 bg-bg2 px-3 py-2.5 md:px-4 md:py-3.5">
      <span
        class="grid size-8 shrink-0 place-items-center rounded-full border border-warn-line bg-warn-soft text-base
               text-warn md:size-9 md:text-lg"
      >
        <ng-icon name="lucideLock" />
      </span>
      <div class="flex-1">
        <p class="text-sm font-semibold leading-snug text-ink">На обложке остались пустые текстовые поля</p>
        <p class="mt-0.75 text-sm leading-normal text-c2">{{ subline() }}</p>
        <div class="mt-2.5 flex flex-wrap gap-2">
          <button hlmBtn type="button" size="sm" (click)="fillCover.emit()">Заполнить или убрать лишние поля</button>
        </div>
      </div>
    </div>
  `,
})
export class CoverGateCardComponent {
  /** Что именно откроется после заполнения — у выдачи ссылок и у сборки альбомов это разные обещания. */
  readonly subline = input('Ссылки откроются, когда вы их заполните или уберёте');
  readonly fillCover = output<void>();
}
